"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetGameDataResponseToJSON = exports.GetGameDataResponseFromJSONTyped = exports.GetGameDataResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function GetGameDataResponseFromJSON(json) {
    return GetGameDataResponseFromJSONTyped(json, false);
}
exports.GetGameDataResponseFromJSON = GetGameDataResponseFromJSON;
function GetGameDataResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'user': !(0, runtime_1.exists)(json, 'user') ? undefined : (0, _1.UserFromJSON)(json['user']),
        'wallets': !(0, runtime_1.exists)(json, 'wallets') ? undefined : (json['wallets'].map(_1.EvmWalletFromJSON)),
    };
}
exports.GetGameDataResponseFromJSONTyped = GetGameDataResponseFromJSONTyped;
function GetGameDataResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'user': (0, _1.UserToJSON)(value.user),
        'wallets': value.wallets === undefined ? undefined : (value.wallets.map(_1.EvmWalletToJSON)),
    };
}
exports.GetGameDataResponseToJSON = GetGameDataResponseToJSON;
